<template>
  <div>
    <!-- <top></top> -->
    <!-- start -->
    <div class="topContent">
      <div class="content bgImgCss">
        <img v-lazy="bgImg" alt class="imgSrcCss">
        <div class="contentPosition">
          <div class="contentTop">老乡鸡</div>
          <div class="contentBottom">
            <div> 中式快餐的餐牌数字化改造</div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
    <!-- 面包屑 start -->
    <!-- <Bread :breadChild="toBreadChild"></Bread> -->
    <!-- 面包屑 end -->
    <div class="titleBox">
      <div class="anliTitle" style="margin-top:38px">项目背景</div>
      <div class="lineCss"></div>
    </div>
    <!-- start -->
    <!-- start -->
    <div class="productParent marginTop109">
      <div class="productLeft">
        <img v-lazy="productLeft1" class="rightImgCss">
      </div>
      <div class="productRight">
        <div class="productRightTitle">
          <div class="titleBox1">
            <!-- <div class="anliTitle">项目背景</div>
            <div class="lineCss1"></div>-->
          </div>
        </div>
        <div
          class="productRightText paddingRight"
        >老乡鸡认为，原有餐牌样式老旧不具有吸引力，且早中晚餐的不同餐牌人工更换，也为店铺运 营增加了人工成本。数拓对餐牌进行数字化改造，实现实时叫号、多功能联屏播放等功能。同时，将门店内原有设备接入数拓系统，实现全场统一化管理。 </div>
      </div>
    </div>
    <!-- end -->

    <!-- <div class="grayBox">
      <div class="titleBox" style="margin-top:0;">
        <div class="anliTitle">方案策略</div>
        <div class="lineCss"></div>
      </div>
      <div
        class="grayBoxText"
    >-->
    <!-- 数拓分析童装消费行为逻辑，从面向店外的针对性家长会员引流，到进店后增加儿童顾客留店时长，再到选购时通过产品溯源对购买率的提升。洞察童装消费本质，以智屏赋能门店，帮助小猪班纳增加消费率的同时，提升会员转化与品牌影响力。</div> -->
    <!-- detailList start -->
    <!-- <div class="detailList">
        <div class="detailBox">
          <img v-lazy="detailListIcon1" alt>
          <div class="detailBoxTitle">数拓智屏OS</div>
        </div>
        <div class="detailBox">
          <img v-lazy="detailListIcon2" alt>
          <div class="detailBoxTitle">第三方系统对接</div>
        </div>
        <div class="detailBox">
          <img v-lazy="detailListIcon3" alt>
          <div class="detailBoxTitle">第三方硬件兼容</div>
        </div>
        <div class="detailBox">
          <img v-lazy="detailListIcon4" alt>
          <div class="detailBoxTitle">天猫数据对接</div>
        </div>
        <div class="detailBox">
          <img v-lazy="detailListIcon5" alt>
          <div class="detailBoxTitle">场景app</div>
        </div>
    </div>-->
    <!-- detailList end -->
    <!-- </div> -->
    <!-- 场景解析 start -->
    <div class="titleBox">
      <div class="anliTitle" style="margin-top:138px">场景功能</div>
      <div class="lineCss"></div>
    </div>

    <div class="bottomParent">
      <div class="bottomLeft">
        <div class="bottomRightTitle bottomRightTitleTwo">旺店大招牌</div>
        <div
          class="bottomRightText bottomRightTextTwo"
        >将老乡鸡原有屏幕接入数拓智能盒，并配置旺店大招牌应用，通过H5的动态效果直观展示‘用农夫山泉煲汤’的制作原则，加深品牌文化烙印。同时，采用定时切换功能，实现早、中、晚餐牌的定时切换，提升运营效率。</div>
      </div>

      <div class="bottomRight">
        <img v-lazy="wanDaContent3" alt>
      </div>
    </div>
  <div class="bottomParent">
      <div class="bottomLeft" style="width:50%;padding:0;">
        <img v-lazy="wanDaContent4" alt>
      </div>
      <div class="bottomRight">
        <div class="bottomRightTitle" >智能叫号</div>

        <div
          class="bottomRightText"
          style="padding-left:10%"
        >对接老乡鸡现有叫号系统，定制专有叫号模板，实时展示配餐和取餐信息，并动态化展示老乡鸡品牌logo，提升服务体验的同时，更加深顾客对品牌的认知。</div>
      </div>
    </div>
    <div class="bottomParent">
      <div class="bottomLeft">
        <div class="bottomRightTitle bottomRightTitleTwo">兼容投影终端</div>
        <div class="bottomRightText bottomRightTextTwo">将老乡鸡现有的展示终端接入数拓智能盒，实现统一化管控，在节日、店庆等日期，统一投放渲染气氛的内容，传播品牌鲜活文化。</div>
      </div>

      <div class="bottomRight" style="width:50%;">
        <img v-lazy="wanDaContent5" alt>
      </div>
    </div>
    <div class="bottomParent">
      <div class="bottomLeft" style="width:50%;padding:0;">
        <img v-lazy="yueYueShangXin" alt>
      </div>
      <div class="bottomRight">
        <div class="bottomRightTitle" >“月月上新”营销活动</div>

        <div
          class="bottomRightText"
          style="padding-left:10%"
        >通过数拓智屏管理系统，我们为老乡鸡月月上新战略，定制了月月加薪联动展示。当月1号，进店消费新菜品，在扫码付款后，系统将进行现金红包抽奖。而中奖结果，将在数拓管控的门店屏幕上同步展示，既增强了活动氛围，又利用门店屏幕扩大了宣传力度，立竿见影地提升了新菜品点单率</div>
      </div>
    </div>
    <!-- 场景解析 end -->

    <!-- end -->
    <Footer></Footer>
  </div>
</template>
<script>
import Top from "@/components/top.vue";
import Footer from "@/components/footer.vue";
import bgImg from "@/assets/images/fellowChickenTop.png";
import productLeft1 from "@/assets/images/fellowChicken1.png";

import wanDaContent2 from "@/assets/images/teBuContent1.png";
import wanDaContent3 from "@/assets/images/fellowChicken2.png";
import wanDaContent4 from "@/assets/images/fellowChicken3.png";
import wanDaContent5 from "@/assets/images/fellowChicken4.png";
import detailListIcon1 from "@/assets/images/teBuIcon1.png";
import detailListIcon2 from "@/assets/images/teBuIcon2.png";
import detailListIcon3 from "@/assets/images/teBuIcon3.png";
import detailListIcon4 from "@/assets/images/teBuIcon4.png";
import detailListIcon5 from "@/assets/images/teBuIcon5.png";
import teBuContent5 from "@/assets/images/gxg4.png";
import teBuContent6 from "@/assets/images/teBuContent6.png";
import teBuContent7 from "@/assets/images/teBuContent7.png";
import northFace2 from "@/assets/images/gxg2.png";
import piglet5 from "@/assets/images/gxg5.png";

import yueYueShangXin from "@/assets/images/yueYueShangXin.jpg";
import Bread from "@/components/bread.vue";

export default {
  name: "CaseFellowChicken",
  components: {
    Top,
    Footer,
    Bread
  },
  data() {
    return {
      yueYueShangXin: yueYueShangXin,
      northFace2: northFace2,
      teBuContent5: teBuContent5,
      teBuContent6: teBuContent6,
      teBuContent7: teBuContent7,
      toBreadChild: ["案例", "老乡鸡"],
      bgImg: bgImg,
      wanDaContent2: wanDaContent2,
      wanDaContent3: wanDaContent3,
      wanDaContent4: wanDaContent4,
      wanDaContent5: wanDaContent5,
      productLeft1: productLeft1,
      piglet5: piglet5,
      detailListIcon1: detailListIcon1,
      detailListIcon2: detailListIcon2,
      detailListIcon3: detailListIcon3,
      detailListIcon4: detailListIcon4,
      detailListIcon5: detailListIcon5
    };
  }
};
</script>
<style scoped>
/* start */
.content {
  position: relative;
}

.bgImgCss {
  width: 100%;
  /* height: 788px; */
}

.imgSrcCss {
  width: 100%;
}

.contentPosition {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 888px;
  height: 90px;
  text-align: center;
}

.contentTop {
  font-size: 8.7rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 37px;
}

.contentBottom {
  text-align: center;
  font-size: 3rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 45px;
}

/* end  */
/* start */
.anliTitle {
  font-size: 3.6rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 40px;
}

.lineCss {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin: auto;
  margin-top: 22px;
}
.lineCss1 {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin-top: 22px;
  margin-bottom: 40px;
}
.lineCssTwo {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin-top: 22px;
}

.titleBox {
  text-align: center;
  margin-top: 100px;
}
.titleBox1 {
}
.titleBoxTwo {
  margin-top: 100px;
  width: 80%;
  margin: auto;
}

/* end */
.productParent::after {
  content: "";
  display: block;
  clear: both;
}
.productParent {
  width: 70%;
  margin: auto;
}

.productLeft {
  width: 44%;
  padding-left: 3%;
  float: left;
}

.productLeft img {
  width: 98%;
  /* max-width: 542px; */
}

.productRight {
  width: 44%;
  padding-left: 5%;
  float: left;
}

.productRightTitle {
  text-indent: 3.8rem;
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin-top: 2%;
  width: 82%;
}

.productRightText {
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 33px;
  margin-top: 30px;
}

.marginTop109 {
  margin-top: 45px;
}

.grayBoxText {
  width: 64%;
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin: auto;
  margin-bottom: 30px;
  margin-top: 68px;
  text-indent: 40px;
}

.grayBox {
  background: rgba(240, 240, 240, 1);
  margin-top: 170px;
  padding-bottom: 68px;
  padding-top: 70px;
}

.detailList {
  display: flex;
  width: 76%;
  margin: auto;
}

.detailBox {
  width: 25%;
  text-align: center;
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  line-height: 40px;
}

.bottomParent {
  width: 70%;
  margin: auto;
}
.bottomParent::after {
  content: "";
  display: block;
  clear: both;
}
.bottomLeft {
  width: 50%;
  float: left;
  margin-top: 84px;
}
.bottomLeft img {
  width: 97%;
  max-width: 586px;
}
.bottomRight img {
  width: 97%;
  /* max-width: 586px; */
}
.bottomRight {
  margin-top: 84px;
  width: 46%;
  float: right;
}
.bottomRightTitle {
  font-size: 3.2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  margin-top: 6%;
  padding-left: 10%;
}
.bottomRightText {
  margin-top: 4%;
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
}
.bottomRightTitleTwo {
}
.bottomRightTextTwo {
  width: 80%;
  margin: auto;
  margin-top: 6%;
}
.paddingRight {
  padding-right: 5%;
}
.rightImgCss {
  width: 100%;
  max-width: 618px;
}
.gapCss {
  font-size: 3.2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  text-align: center;
  margin-top: 139px;
}
</style>



// WEBPACK FOOTER //
// src/view/CaseFellowChicken.vue